<template>
    <div
        v-if="globalProps.demoEligible"
        class="group fixed right-0 top-24 z-[650] hidden items-stretch translate-x-[calc(100%-1.25rem)] transition-transform duration-200 ease-out focus-within:translate-x-0 hover:translate-x-0 md:flex"
    >
        <div
            :title="globalProps.demoMode ? 'Demo data: ON' : 'Demo data: OFF'"
            class="flex w-5 items-center justify-center rounded-l-lg"
            :class="globalProps.demoMode ? 'bg-[#FFC000]' : 'bg-[#161E2E]'"
        >
            <ChevronLeftIcon
                class="h-4 w-4"
                :class="globalProps.demoMode ? 'text-gray-900' : 'text-white'"
            />
        </div>

        <div class="w-64 border border-l-0 border-gray-200 bg-white shadow-2xl">
            <div
                class="flex items-center gap-2 border-b border-gray-100 px-4 py-3"
            >
                <WrenchScrewdriverIcon class="h-4 w-4 text-gray-400" />
                <span
                    class="text-xs font-semibold uppercase tracking-wide text-gray-500"
                >
                    Admin tools
                </span>
            </div>

            <div class="flex items-center justify-between gap-3 px-4 py-3">
                <span class="min-w-0">
                    <span class="block text-sm font-medium text-gray-800">
                        Demo data
                    </span>
                    <span class="block text-xs text-gray-400">
                        Showcase sample reports (read-only)
                    </span>
                </span>
                <AtomicSwitch
                    :model-value="globalProps.demoMode"
                    :title="
                        globalProps.demoMode
                            ? 'Demo data: ON — click to turn off'
                            : 'Demo data — click to turn on'
                    "
                    class="shrink-0 [&_button:hover]:ring-2 [&_button:hover]:ring-gray-400 [&_button:hover]:ring-offset-1 [&_button]:cursor-pointer [&_button]:transition-shadow"
                    @update:model-value="toggleDemoMode"
                />
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { router, usePage } from "@inertiajs/vue3";
import route from "ziggy-js";
import {
    ChevronLeftIcon,
    WrenchScrewdriverIcon,
} from "@heroicons/vue/24/outline";
import AtomicSwitch from "@/components/Atomic/Switch/Switch.vue";
import type { IRhizomPageProps } from "@/types/RhizomPageProps/RhizomPageProps";

const globalProps = computed(() => usePage<IRhizomPageProps>().props);

const toggleDemoMode = () => {
    router.put(route("demo-mode.toggle"), {}, { preserveScroll: true });
};
</script>
